import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import '../styles/NewInfoRow.css';

const NewInfoRow = ({labelId, arvo, customStyles, className}) => {
  return (
    <div className={`new-info-row row ${className}`} style={customStyles}>
      {labelId && (
        <div className="col-6 new-info-row__label">
          <p className="body-lg-bold">
            <FormattedMessage id={labelId} defaultMessage={labelId} />:
          </p>
        </div>
      )}
      <div className="col-6 new-info-row__value">
        <p className="body-sm">
          {Array.isArray(arvo)
            ? arvo.map((subArvo, index) => (
                <span key={index}>
                  {subArvo}
                  <br />
                </span>
              ))
            : arvo}
        </p>
      </div>
    </div>
  );
};

NewInfoRow.propTypes = {
  labelId: PropTypes.string,
  arvo: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  customStyles: PropTypes.object,
  className: PropTypes.string // Added className prop
};

export default NewInfoRow;
